import { render } from "./OptionButton.vue?vue&type=template&id=66aeb95f"
import script from "./OptionButton.vue?vue&type=script&lang=js"
export * from "./OptionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__